import React, { Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import ax from "./auth/axios";
import { API_ROOT } from "./utils/api-config";
import { connect } from "react-redux";
import { editCustomerProfile } from "../actions/customerAction";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Navbar from "react-bootstrap/Navbar";

class EditCustomerProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      latest_address: "",
      latest_address2: "",
      latest_city: "",
      latest_zip: "",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { customer } = this.props;
    this.setState({
      first_name: customer.first_name,
      last_name: customer.last_name,
      email: customer.email,
      phone: customer.phone,
      latest_address: customer.latest_address,
      latest_address2: customer.latest_address2,
      latest_city: customer.latest_city,
      latest_zip: customer.latest_zip,
    });
  }
  handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData();
    let token = "Bearer " + localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: token,
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
    formData.append("customer[first_name]", this.state.first_name);
    formData.append("customer[last_name]", this.state.last_name);
    formData.append("customer[email]", this.state.email);
    formData.append("customer[latest_address]", this.state.latest_address);
    formData.append("customer[latest_address2]", this.state.latest_address2);
    formData.append("customer[latest_city]", this.state.latest_city);
    formData.append("customer[latest_zip]", this.state.latest_zip);
    ax.patch(
      `${API_ROOT}/customers/${this.props.match.params.id}`,
      formData,
      config
    ).then((response) => {
      this.props.editCustomerProfile(response.data);
    });
  }
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }
  render() {
    return (
      <div className="container-fluid">
        <Navbar className="bg-info justify-content-between">
          <Navbar.Brand>
            Edit Customer Profile of {this.state.first_name}{" "}
            {this.state.last_name}
          </Navbar.Brand>
        </Navbar>
        <Form onSubmit={this.handleSubmit}>
          <br></br>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridFirstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                onChange={this.handleInputChange}
                name="first_name"
                value={this.state.first_name}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridLastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                name="last_name"
                onChange={this.handleInputChange}
                value={this.state.last_name}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                onChange={this.handleInputChange}
                value={this.state.email ? this.state.email : ""}
              />
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridPhone">
              <Form.Label>Phone</Form.Label>
              <Form.Control
                name="phone"
                onChange={this.handleInputChange}
                value={this.state.phone ? this.state.phone : ""}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridAddress">
              <Form.Label>Address</Form.Label>
              <Form.Control
                name="latest_address"
                onChange={this.handleInputChange}
                value={this.state.latest_address}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridAddress2">
              <Form.Label>Apt/Unit </Form.Label>
              <Form.Control
                name="latest_address2"
                onChange={this.handleInputChange}
                value={this.state.latest_address2}
              />
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridCity">
              <Form.Label>City</Form.Label>
              <Form.Control
                name="latest_city"
                onChange={this.handleInputChange}
                value={this.state.latest_city}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridPostalCode">
              <Form.Label>Postal Code</Form.Label>
              <Form.Control
                name="latest_zip"
                onChange={this.handleInputChange}
                value={this.state.latest_zip}
              />
            </Form.Group>
          </Form.Row>
          <Button type="submit" variant="outline-danger">
            Save Changes
          </Button>
        </Form>
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  editCustomerProfile: (customer) => dispatch(editCustomerProfile(customer)),
});
export default withRouter(
  connect(null, mapDispatchToProps)(EditCustomerProfile)
);
